import React, { useEffect, useState } from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function RoleBasedSkills({ jobseeker, ref }) {
    const { t, i18n } = useTranslation();
    const [filteredRoleSkills, setFilteredRoleSkills] = useState([]);
    
    // Use Redux to get real-time user data
    const reduxUser = useSelector(state => state.user.user);
    
    // Process and filter role skills whenever jobseeker or user data changes
    useEffect(() => {
        // Use either jobseeker prop or Redux user data
        const currentUser = jobseeker || reduxUser;
        
        if (currentUser) {
            // Get job titles from user preferences and filter out empty titles
            const jobTitles = currentUser?.jobPreferences?.[0]?.jobTitles?.filter(title => title && title.trim() !== '') || [];
            
            // Filter roleBasedSkills to only include those that match job preferences
            const filtered = currentUser?.roleBasedSkills?.filter(roleSkill => {
                const roleName = i18n.language === 'en' ? roleSkill.role_name_en : roleSkill.role_name_ar;
                return roleName && roleName.trim() !== '' && jobTitles.includes(roleName);
            }) || [];
            
            setFilteredRoleSkills(filtered);
        }
    }, [jobseeker, reduxUser, i18n.language]);

    return (
        <div ref={ref} id="roleSkills" className={styles.overViewContainer} style={{ backgroundColor:  'transparent' ,padding:'0px',marginBottom:'0px'}}>
            <h2 className={`${styles.heading} ${styles.removeMarginBottom}`}>
                {t('overview.roleBasedSkills')}
            </h2>
            {filteredRoleSkills.length > 0 ? (
                filteredRoleSkills.map((roleSkill, index) => (
                    <div key={index} className={styles.roleSkillContainer}>
                        <h3 className={styles.title}>
                            {i18n.language === 'en' ? roleSkill.role_name_en : roleSkill.role_name_ar}
                        </h3>
                        <div>
                            {roleSkill.skills && roleSkill.skills.map((skill, skillIndex) => (
                                <span key={skillIndex} className={styles.skillChip}>
                                    {skill}
                                </span>
                            ))}
                        </div>
                    </div>
                ))
            ) : (
                <p className={styles.description} style={{ marginTop: '15px' }}>
                    {t('overview.noRoleSkills', 'No role-based skills have been added for the preferred job titles.')}
                </p>
            )}
        </div>
    );
}

export default RoleBasedSkills; 